import Sagas from 'modules/User/Profile/saga'
import Reducer from 'modules/User/Profile/reducer'
import Profile from 'modules/User/Profile/Profile'

export default Profile

export { Sagas, Reducer }
